export class ItemRelatorioVm {
  titulo: string;
  endereco_relatorio: string;

  constructor(titulo: string, endereco_relatorio: string) {
    this.titulo = titulo;
    this.endereco_relatorio = endereco_relatorio;
  }
}
